import * as React from "react";
import * as Highlighter from "react-highlight-words";
import { LocStoreInstance } from ".";
import { getTranslatedText } from "./getTranslatedText";

export function loc(
  inputText: string,
  searchWords: string[],
  stringContext: string,
  id: string,
  locStoreInstance: LocStoreInstance
): any {
  const translatedText = getTranslatedText(
    inputText,
    searchWords,
    stringContext,
    id,
    locStoreInstance
  );

  if (searchWords) {
    return (
      <Highlighter
        searchWords={searchWords}
        autoEscape
        textToHighlight={translatedText}
      />
    );
  }

  if (typeof translatedText !== "string") {
    return inputText;
  }

  return translatedText;
}
